import React from "react";

export default function App() {
  return (
        <section className='section'>
          <h3 className='section-title'>Interests</h3>
          <p className='section-body'>Knitting. Crochet. Drawing. Japanese Culture. Food enthusiasm. Music fanatic. Gamer geek. Travel explorer. Coffee lover.</p>
        </section>
  );
}